import { render, staticRenderFns } from "./ZRD_Result.vue?vue&type=template&id=edecfc7a&scoped=true&"
import script from "./ZRD_Result.vue?vue&type=script&lang=js&"
export * from "./ZRD_Result.vue?vue&type=script&lang=js&"
import style0 from "./ZRD_Result.vue?vue&type=style&index=0&id=edecfc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edecfc7a",
  null
  
)

export default component.exports